import { render, staticRenderFns } from "./Celebrations.vue?vue&type=template&id=1aaecca0&scoped=true&"
import script from "./Celebrations.vue?vue&type=script&lang=js&"
export * from "./Celebrations.vue?vue&type=script&lang=js&"
import style0 from "./Celebrations.vue?vue&type=style&index=0&id=1aaecca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaecca0",
  null
  
)

export default component.exports